import { ArrayCallback, requestAction } from "../actionlog/actionLogActions"
import OrderAttempt from "./OrderAttempt"
import { REMOVE_ORDER_ATTEMPT, UPDATE_ORDER_ATTEMPT_LIST } from "./orderAttemptActionTypes"
import OrderAttemptService from "./OrderAttemptService"

export function clearOrderAttemptListing() {
    return updateOrderAttemptListing([])
}

export function updateOrderAttemptListing(orderAttempts: OrderAttempt[]) {
    return {
        type: UPDATE_ORDER_ATTEMPT_LIST,
        payload: {
            orderAttempts: orderAttempts.map(o => o.dto),
        }
    }
}

export function removeOrderAttempt(id: string) {
    return {
        type: REMOVE_ORDER_ATTEMPT,
        payload: {
            orderAttemptId: id,
        }
    }
}

export function retryOrderAttempt(id: string, actionId: string) {
    return async (dispatch) => {
        dispatch(
            requestAction<void>(
                () => OrderAttemptService.retryOrderAttempt(id),
                () => removeOrderAttempt(id),
                actionId,
            )
        )
    }
}

export function dismissOrderAttempt(id: string, actionId: string) {
    return async (dispatch) => {
        dispatch(
            requestAction<OrderAttempt>(
                () => OrderAttemptService.dismissOrderAttempt(id),
                () => removeOrderAttempt(id),
                actionId,
            )
        )
    }
}

export function fetchOrderAttempts(priceListId: string, actionId: string) {
    return async (dispatch) => {
        dispatch(
            requestAction<OrderAttempt>(
                () => OrderAttemptService.fetchOrderAttempts(priceListId),
                updateOrderAttemptListing as ArrayCallback<OrderAttempt>,
                actionId,
            )
        )
    }
}




// WEBPACK FOOTER //
// ./src/state/price-list/orderAttemptActions.ts